export default () => {
  const getButton = () => {
    return document.getElementById('whappe-button');
  };
  {
    const whappieOpenLinks = Array.from(document.querySelectorAll('a[href="$whappie_open"]'));
    const setupOpenLinks = element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const button = getButton();
        if (button) {
          button.click();
        }
      });
    };
    for (const whappieOpenLink of whappieOpenLinks) {
      setupOpenLinks(whappieOpenLink);
    }
  }
};